import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getToDate } from "../../utils/utils";
import { blockStatement } from "@babel/types";
import SimpleReactValidator from "simple-react-validator";
import { PopupMessage } from "../../utils/utils";
import moment from "moment";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LeaseTermDetails extends React.Component {
  state = {
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    initialValues: {
      renewalTerms: [],
      totalRenewalTerms: 0,
    },
    isDisabled: true,
    fitoutEndDate: "",
    fitoutStartDate: "",
    fitoutPeriod: "",
    leaseCommencementDate: "",
    renewalCommencementDate: "",
    rentFreePeriodDays: "",
    rentFreePeriodMonths: "",
    rentCommencementDate: "",
    companyName: [],
    tower: [],
    occupierGroups: [],
    countries: [],
    states: [],
    cities: [],
    redirect: false,
    leaseTermYY: "",
    leaseTermMM: "",
    leaseTermDD: "",
    leaseExpiryDate: "",
    isLeaseRegistered: false,
  };
  constructor(props) {
    super(props);
    this.calculateFitoutEndDate.bind(this);
    this.calculateLeaseCommencementDate.bind(this);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }
  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/occupier-groups`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          occupierGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/countries`,{ headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    
    let athis=this;
    axios.get(`${apiUrl.apiUrl.url}/create-lease/fetch-lease-term-form?id=${this.props.match.params.id}`).then((response) => {
      let data = response.data;
      if (data.rentFreePeriodDays == 0) {
        athis.setState({ rentFreePeriodDays: "" });
      } else {
        athis.setState({ rentFreePeriodDays: data.rentFreePeriodDays });
      }
      if (
        data.rentFreePeriodMonths == 0 ||
        data.rentFreePeriodMonths === undefined
      ) {
        athis.setState({ rentFreePeriodMonths: "" });
      } else {
        athis.setState({ rentFreePeriodMonths: data.rentFreePeriodMonths });
      }
      if (data.leaseTermDD == 0) {
        athis.setState({ leaseTermDD: "" });
      } else {
        athis.setState({ leaseTermDD: data.leaseTermDD });
      }
      if (data.leaseTermMM == 0) {
        athis.setState({ leaseTermMM: "" });
      } else {
        athis.setState({ leaseTermMM: data.leaseTermMM });
      }
      if (data.leaseTermYY == 0) {
        athis.setState({ leaseTermYY: "" });
      } else {
        athis.setState({ leaseTermYY: data.leaseTermYY });
      }
      data.totalRenewalTerms = data.renewalTerms.length;
      athis.setState({
        initialValues: data,
      });
      athis.setState({
        fitoutEndDate: getToDate(
          data.fitoutStartDate,
          Number(data.fitoutPeriod),
          0,
          0
        ),
      });
      athis.setState({
        leaseCommencementDate: getToDate(data.fitoutEndDate, Number(1), 0, 0),
      });
      athis.setState({
        rentCommencementDate: getToDate(
          data.leaseCommencementDate,
          Number(data.rentFreePeriodDays),
          0,
          0
        ),
      });
      athis.setState({
        leaseExpiryDate: getToDate(
          data.leaseCommencementDate,
          data.leaseTermYY,
          data.leaseTermDD,
          data.leaseTermMM
        ),
      });
    });

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-term-form?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     if (data.rentFreePeriodDays == 0) {
    //       this.setState({ rentFreePeriodDays: "" });
    //     } else {
    //       this.setState({ rentFreePeriodDays: data.rentFreePeriodDays });
    //     }
    //     if (
    //       data.rentFreePeriodMonths == 0 ||
    //       data.rentFreePeriodMonths === undefined
    //     ) {
    //       this.setState({ rentFreePeriodMonths: "" });
    //     } else {
    //       this.setState({ rentFreePeriodMonths: data.rentFreePeriodMonths });
    //     }
    //     if (data.leaseTermDD == 0) {
    //       this.setState({ leaseTermDD: "" });
    //     } else {
    //       this.setState({ leaseTermDD: data.leaseTermDD });
    //     }
    //     if (data.leaseTermMM == 0) {
    //       this.setState({ leaseTermMM: "" });
    //     } else {
    //       this.setState({ leaseTermMM: data.leaseTermMM });
    //     }
    //     if (data.leaseTermYY == 0) {
    //       this.setState({ leaseTermYY: "" });
    //     } else {
    //       this.setState({ leaseTermYY: data.leaseTermYY });
    //     }
    //     data.totalRenewalTerms = data.renewalTerms.length;
    //     this.setState({
    //       initialValues: data,
    //     });
    //     this.setState({
    //       fitoutEndDate: getToDate(
    //         data.fitoutStartDate,
    //         Number(data.fitoutPeriod),
    //         0,
    //         0
    //       ),
    //     });
    //     this.setState({
    //       leaseCommencementDate: getToDate(data.fitoutEndDate, Number(1), 0, 0),
    //     });
    //     this.setState({
    //       rentCommencementDate: getToDate(
    //         data.leaseCommencementDate,
    //         Number(data.rentFreePeriodDays),
    //         0,
    //         0
    //       ),
    //     });
    //     this.setState({
    //       leaseExpiryDate: getToDate(
    //         data.leaseCommencementDate,
    //         data.leaseTermYY,
    //         data.leaseTermDD,
    //         data.leaseTermMM
    //       ),
    //     });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  changeOccupier = (e) => {
    let groupid = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/occupier/get-group-companies/?id=` + groupid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          companyName: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeCountry = (e) => {
    let countryid = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + countryid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeState = (e) => {
    let stateId = e.target.value;
    console.log(stateId, "SI");
    fetch(`${apiUrl.apiUrl.url}/cities/state-cities/` + stateId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data");
        this.setState({
          cities: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  changeLeaseTerms = (e) => {
    this.state.initialValues.totalRenewalTerms = e.target.value;
    if (this.state.initialValues.renewalTerms.length < e.target.value) {
      var toAppend =
        e.target.value - this.state.initialValues.renewalTerms.length;
      for (var i = 0; i < toAppend; i++) {
        this.state.initialValues.renewalTerms.push({});
      }
    }
  };

  addRenewalTerms = (e) => {
    console.log(e.target.value, "vv");
    this.state.initialValues.totalRenewalTerms = e.target.value;
    if (this.state.initialValues.renewalTerms.length < e.target.value) {
      var toAppend =
        e.target.value - this.state.initialValues.renewalTerms.length;
      for (var i = 0; i < toAppend; i++) {
        this.state.initialValues.renewalTerms.push({
          year: 0,
          month: 0,
          date: 0,
          renewalNoticeDueDate: "",
        });
      }
    } else if (this.state.initialValues.renewalTerms.length > e.target.value) {
      var toRemove =
        this.state.initialValues.renewalTerms.length - e.target.value;
      for (var i = 0; i < toRemove; i++) {
        this.state.initialValues.renewalTerms.pop({});
      }
    }
  };

  checkLeaseRegistrationDate(e, values) {
    if (e.target.checked) {
      this.state.isDisabled = false;
      this.state.isLeaseRegistered = true;
    } else {
      this.state.isDisabled = true;
      this.state.isLeaseRegistered = false;
    }
    this.setState({});
  }

  calculateFitoutEndDate(e, values) {
    console.log(values);
    values.fitoutEndDate = getToDate(
      values.fitoutStartDate,
      Number(this.state.fitoutPeriod),
      0,
      0
    );
    this.calculateLeaseCommencementDate(e, values);
    this.setState({});
  }

  calculateLeaseCommencementDate(e, values) {
    values.leaseCommencementDate = getToDate(
      values.fitoutEndDate,
      Number(2),
      0,
      0
    );
    this.calculateRentCommencementDate(e, values);
    this.calculateLeaseExpiryDate(e, values);
    this.setState({});
  }

  calculateRentCommencementDate(e, values) {
    if (e.target.value == 0) {
      values.rentCommencementDate = values.leaseCommencementDate;
    }
    values.rentCommencementDate = getToDate(
      values.leaseCommencementDate,
      Number(values.rentFreePeriodDays) + 1,
      Number(values.rentFreePeriodMonths),
      0
    );
    this.setState({});
  }

  calculateLeaseExpiryDate(e, values) {
    values.leaseExpiryDate = getToDate(
      values.leaseCommencementDate,
      Number(this.state.leaseTermDD),
      Number(this.state.leaseTermMM),
      Number(this.state.leaseTermYY)
    );
    this.calculateLeaseDeadEndDate(e, values);
    this.setState({});
  }

  calculateLeaseDeadEndDate(e, values) {
    var numberOfDays = 0;
    var numberOfMonths = 0;
    var numberOfYears = 0;
    for (let i = 0; i < values.renewalTerms.length; i++) {
      numberOfDays += Number(values.renewalTerms[i].date);
      numberOfMonths += Number(values.renewalTerms[i].month);
      numberOfYears += Number(values.renewalTerms[i].year);
      // console.log()
    }
    values.leaseDeadEndDate = getToDate(
      values.leaseExpiryDate,
      Number(numberOfDays) + Number(1),
      Number(numberOfMonths),
      Number(numberOfYears)
    );
    this.setState({});
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  getDateDiff = (e, values) => {
    var a = moment(e.target.value);
    var b = moment(values.leaseCommencementDate);
    var years = a.diff(b, "year");
    b.add(years, "years");
    var months = a.diff(b, "months");
    b.add(months, "months");
    var days = a.diff(b, "days");
    this.setState({
      leaseTermYY: years,
      leaseTermMM: months,
      leaseTermDD: Number(days) + 1,
    });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match.path;
      let urlPath = url.split("/");
      this.state.redirect = false;
      return (
        <Redirect
          push
          // to={
          //   "/createlease/lock-in-notice-period/" + this.props.match.params.id
          // }
          to={
            `/${urlPath[1]}/lock-in-notice-period/` + this.props.match.params.id
          }
        />
      );
    }
    return (
      <div
        className="parentContainer createLease">
        <div>
          <div className="absoluteItemForTopBar">
            <div className="new_breadcrumbs_design">
              <ul className="d-flex align-items-center gap-3 p-0 m-0">
                <li>Create Lease</li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>Critical Dates</li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>
                  <a href="#">Lease Term Details</a>
                </li>
              </ul>
            </div>
          </div>

          <Formik
            initialValues={this.state.initialValues}
            enableReinitialize
            onSubmit={(values, actions) => {
              if (!this.mainFormValidator.allValid()) {
                this.mainFormValidator.showMessages();
                return false;
              }
              var self = this;
              axios({
                method: "post",
                url: `${apiUrl.apiUrl.url}/create-lease/update-lease-term?lease_id=${this.props.match.params.id}`,
                data: values,
              }).then(function (response) {
                if (!response.data.success) {
                  actions.setSubmitting(false);
                  actions.setErrors(response.data);
                } else {
                  self.setState({ messsagePopup: true });
                }
              });
            }}
          >
            {({
              values,

              errors,

              touched,

              handleChange,

              handleBlur,

              handleSubmit,

              isSubmitting,
            }) => (
              <>
                <div className="unitFormContainerNew">
                  <Form autoComplete="off" >
                    <div className="newGridSectionParent">
                      <div className="newGridSectionForFormMain align-items-start">

                        <div className="newGridSectionInner">
                          <label>
                            Lease Document <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              as={"select"}
                              name={"leaseDocument"}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                              <option
                                value="Commercial Approval Note"
                                label="Commercial Approval Note"
                              />
                              <option value="Expression of Intent" label="Expression of Intent" />
                              <option value="Letter of Intent" label="Letter of Intent" />
                              <option value="Term Sheet" label="Term Sheet" />
                              <option value="agreement-to-lease" label="Agreement to Lease" />
                              <option value="Agreement to License" label="Agreement to License" />
                              <option value="Lease Deed" label="Lease Deed" />
                              <option
                                value="Leave and License Agreement"
                                label="Leave and License Agreement"
                              />
                            </Field>
                            {this.mainFormValidator.message(
                              "lease Document",
                              values.leaseDocument,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Lease Creation Date <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              type="date"
                              name="leaseCreationDate"
                              readOnly="true"
                            />
                            {this.mainFormValidator.message(
                              "lease Creation Date",
                              values.leaseCreationDate,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Lease Document Date <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              type="date"
                              name="leaseDocumentDate"
                            />
                            {this.mainFormValidator.message(
                              "lease Document Date",
                              values.leaseDocumentDate,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            LOI Date
                          </label>
                          <div className="position-relative">
                            <Field
                              type="date"
                              name="invoiceSingingDate"
                              // readOnly="true"
                            />
                            {this.mainFormValidator.message(
                              "Invoice Signing Date",
                              values.invoiceSingingDate,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Lease Registration Date
                          </label>
                          <div className="position-relative">
                            <div className="row m-0 align-items-center">
                              <div className="col-sm-6 ps-0">
                                <div className="d-flex gap-2">
                                  <Field
                                    type="checkbox"
                                    name="leaseRegistered"
                                    value="leaseRegistered"
                                    className="sameAs"
                                    id="leaseRegistered"
                                    style={{ width: "fit-content" }}
                                    checked={this.state.isLeaseRegistered} // Set condition for checked
                                    onClick={(e) => {
                                      this.checkLeaseRegistrationDate(e, values);
                                    }}
                                  />
                                  <label htmlFor="leaseRegistered">Lease Registered</label>
                                </div>
                              </div>
                              <div className="col-sm-6 pe-0">
                                <Field
                                  type="date"
                                  name="leaseRegistrationDate"
                                  disabled={this.state.isDisabled}
                                />
                                {this.mainFormValidator.message(
                                  "lease Registration Date",
                                  values.leaseRegistrationDate,
                                  "",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Fitout Letter Date <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              type="date"
                              name="fitoutLetterDate"
                            />
                            {this.mainFormValidator.message(
                              "fitout Letter Date",
                              values.fitoutLetterDate,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Fitout Start Date <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              type="date"
                              name="fitoutStartDate"
                              onChange={(e) => {
                                this.state.fitoutStartDate = e.target.value;
                                this.calculateFitoutEndDate(e, values);
                                handleChange(e);
                              }}
                              onBlur={(e) => {
                                this.calculateFitoutEndDate(e, values);
                              }}
                            />
                            {this.mainFormValidator.message(
                              "fitout Start Date",
                              values.fitoutStartDate,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Fitout Period (Days)
                          </label>
                          <div className="position-relative">
                            <Field
                              type="text"
                              name="fitoutPeriod"
                              placeholder="DD (Days)"
                              className="leftAlignPlaceholder"
                              onChange={(e) => {
                                this.state.fitoutPeriod = e.target.value;
                                handleChange(e);
                              }}
                              onBlur={(e) => {
                                this.calculateFitoutEndDate(e, values);
                                this.calculateLeaseCommencementDate(e, values);
                              }}
                            />
                            <ErrorMessage
                              name="fitoutPeriod"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Unit Possession Date <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              type="date"
                              name="unitPossessionDate"
                            />
                            {this.mainFormValidator.message(
                              "Unit Possession Date",
                              values.unitPossessionDate,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Fitout End Date <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              type="date"
                              name="fitoutEndDate"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                            {this.mainFormValidator.message(
                              "fitout End Date",
                              values.fitoutEndDate,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Lease Commencement Date <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              type="date"
                              name="leaseCommencementDate"
                              onChange={(e) => {
                                this.calculateRentCommencementDate(e, values);
                                handleChange(e);
                              }}
                              onBlur={(e) => {
                                this.calculateRentCommencementDate(e, values);
                              }}
                            />
                            {this.mainFormValidator.message(
                              "Lease Commencement Date",
                              values.leaseCommencementDate,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>
                        {
                          this.state.initialValues.renewalCommencementDate != "0000-00-00" && (
                            <div className="newGridSectionInner">
                              <label>
                                Renewal Commencement Date
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="renewalCommencementDate"
                                  readOnly
                                />
                              </div>
                            </div>
                          )
                        }  

                        {
                          this.state.initialValues.renewalCommencementDate == "0000-00-00" && (
                            <div className="newGridSectionInner"></div>
                          )
                        }    
                        

                        <div className="newGridSectionInner">
                          <label>
                            Rent Free Period (Days) (Operational)
                          </label>
                          <div className="position-relative">
                            <div className="row m-0">
                              <div className="col-sm-6 ps-0 leaseTermFieldWidth">
                                <Field
                                  type="text"
                                  name="rentFreePeriodMonths"
                                  placeholder="MM"
                                  className="centerPlaceHolder"
                                  value={this.state.rentFreePeriodMonths}
                                  onChange={(e) => {
                                    this.state.rentFreePeriodMonths = e.target.value;
                                    handleChange(e);
                                  }}
                                  onBlur={(e) => {
                                    this.calculateRentCommencementDate(e, values);
                                  }}
                                />
                              </div>
                              <div className="col-sm-6 pe-0 leaseTermFieldWidth">
                                <Field
                                  type="text"
                                  name="rentFreePeriodDays"
                                  placeholder="DD"
                                  className="centerPlaceHolder"
                                  value={this.state.rentFreePeriodDays}
                                  onChange={(e) => {
                                    this.state.rentFreePeriodDays = e.target.value;
                                    handleChange(e);
                                  }}
                                  onBlur={(e) => {
                                    this.calculateRentCommencementDate(e, values);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Rent Commencement Date <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              type="date"
                              name="rentCommencementDate"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                            />
                            {this.mainFormValidator.message(
                              "Rent Commencement Date",
                              values.rentCommencementDate,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Lease Term <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <div className="row m-0">
                              <div className="col-sm-4 p-0 leaseTermFieldWidth">
                                <Field
                                  type="text"
                                  name="leaseTermYY"
                                  placeholder="YY"
                                  className="centerPlaceHolder"
                                  value={this.state.leaseTermYY}
                                  onChange={(e) => {
                                    this.state.leaseTermYY = e.target.value;
                                    this.calculateLeaseExpiryDate(e, values);
                                    handleChange(e);
                                  }}
                                  onBlur={(e) => {
                                    this.calculateLeaseExpiryDate(e, values);
                                  }}
                                />
                              </div>
                              <div className="col-sm-4 leaseTermFieldWidth">
                                <Field
                                  type="text"
                                  name="leaseTermMM"
                                  placeholder="MM"
                                  className="centerPlaceHolder"
                                  value={this.state.leaseTermMM}
                                  onChange={(e) => {
                                    this.state.leaseTermMM = e.target.value;
                                    this.calculateLeaseExpiryDate(e, values);
                                    handleChange(e);
                                  }}
                                  onBlur={(e) => {
                                    this.calculateLeaseExpiryDate(e, values);
                                  }}
                                />
                              </div>
                              <div className="col-sm-4 p-0 leaseTermFieldWidth">
                                <Field
                                  type="text"
                                  name="leaseTermDD"
                                  placeholder="DD"
                                  className="centerPlaceHolder"
                                  value={this.state.leaseTermDD}
                                  onChange={(e) => {
                                    this.state.leaseTermDD = e.target.value;
                                    this.calculateLeaseExpiryDate(e, values);
                                    handleChange(e);
                                  }}
                                  onBlur={(e) => {
                                    this.calculateLeaseExpiryDate(e, values);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Lease Expiry Date Section */}
                        <div className="newGridSectionInner">
                          <label>
                            Lease Expiry Date <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              type="date"
                              name="leaseExpiryDate"
                              onChange={(e) => {
                                this.getDateDiff(e, values);
                                values.leaseExpiryDate = e.target.value;
                                values.leaseDeadEndDate = e.target.value;
                                this.setState({});
                              }}
                            />
                            {this.mainFormValidator.message(
                              "Lease Expiry Date",
                              moment(values.leaseExpiryDate).format("yyyy-MM-dd"),
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>

                        {/* <div className="newGridSectionInner"></div> */}

                        <div className="newGridSectionInner">
                          <label>
                            Total Renewal Terms
                          </label>
                          <div className="position-relative">
                            <Field
                              type="text"
                              name="totalRenewalTerms"
                              value={this.state.initialValues.totalRenewalTerms}
                              onChange={(e) => {
                                handleChange(e);
                                this.addRenewalTerms(e);
                              }}
                            />
                            <ErrorMessage
                              name="totalRenewalTerms"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Lease Dead End Date <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field type="date" name="leaseDeadEndDate" />
                            {this.mainFormValidator.message(
                              "Lease Dead End Date",
                              values.leaseDeadEndDate,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>


                        <div className="renewalTermMain">
                          {this.state.initialValues.renewalTerms.length > 0 &&
                            this.state.initialValues.renewalTerms.map((term, index) => (
                              <div className="newGridSectionInner" key={index}>
                                <label>
                                  {`Renewal Term(s) ${index + 1}`}{" "}
                                  <span style={{ display: "block" }}>
                                    (YY-MM-DD) <span className="astrik">*</span>
                                  </span>
                                </label>
                                <div className="position-relative">
                                  <div className="row m-0">
                                    <div className="col-sm-4 p-0 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name={`renewalTerms.${index}.year`}
                                        placeholder="YY"
                                        className="centerPlaceHolder"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        onBlur={(e) => {
                                          this.calculateLeaseDeadEndDate(e, values);
                                        }}
                                      />
                                    </div>
                                    <div className="col-sm-3 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name={`renewalTerms.${index}.month`}
                                        placeholder="MM"
                                        className="centerPlaceHolder"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        onBlur={(e) => {
                                          this.calculateLeaseDeadEndDate(e, values);
                                        }}
                                      />
                                    </div>
                                    <div className="col-sm-4 p-0 leaseTermFieldWidth">
                                      <Field
                                        type="text"
                                        name={`renewalTerms.${index}.date`}
                                        placeholder="DD"
                                        className="centerPlaceHolder"
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        onBlur={(e) => {
                                          this.calculateLeaseDeadEndDate(e, values);
                                        }}
                                      />
                                    </div>
                                    <div className="col-sm-1 pe-0">
                                      <button
                                        type="button"
                                        className="secondary"
                                        onClick={(e) => {
                                          this.state.initialValues.totalRenewalTerms--;
                                          var _renewalTerms = this.state.initialValues.renewalTerms;
                                          _renewalTerms.splice(index, 1);
                                          values.renewalTerms.splice(index, 1);
                                          this.setState({
                                            renewalTerms: _renewalTerms,
                                          });
                                        }}
                                      >
                                        X
                                      </button>
                                    </div>
                                  </div>
                                  <ErrorMessage
                                    name="renewalTerm"
                                    component="div"
                                    className="text-red"
                                  />

                                </div>
                              </div>
                            ))}
                        </div>

                        <div className="RenewalNoticeDue">
                          {this.state.initialValues.renewalTerms.length > 0 &&
                            values.totalRenewalTerms > 0 &&
                            this.state.initialValues.renewalTerms.map((term, index) => (
                              <div className="newGridSectionInner" key={index}>
                                <label>
                                  {`Renewal ${index + 1} Notice Due Before Expiry (in Months)`}{" "}
                                  <span className="astrik">*</span>
                                </label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name={`renewalTerms.${index}.renewalNoticeDueDate`}
                                  >
                                    <option value="" label="Select" defaultValue />
                                    <option value="One Month" label="One Month" />
                                    <option value="Two Months" label="Two Months" />
                                    <option value="Three Months" label="Three Months" />
                                    <option value="Four Months" label="Four Months" />
                                    <option value="Five Months" label="Five Months" />
                                    <option value="Six Months" label="Six Months" />
                                  </Field>
                                  <ErrorMessage
                                    name={`renewalTerms.${index}.renewalNoticeDueDate`}
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            ))}
                        </div>

                        <div className="newGridSectionInner">
                          <label>
                            Renewal Period Commercial Input <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              as="select"
                              name="renewalPeriodCommercialInput"
                            >
                              <option value="" label="Select" defaultValue />
                              <option value="Yes" label="Yes" />
                              <option value="No" label="No" />
                            </Field>
                            {this.mainFormValidator.message(
                              "Renewal Period Commercial Input",
                              values.renewalPeriodCommercialInput,
                              "required",
                              { className: "text-danger" }
                            )}
                          </div>
                        </div>
                        <div className="gridColOneByThree">
                          {/* <label>
                            Lease Dead End Date <span className="astrik">*</span>
                          </label> */}
                          <span className="remarks">Notes/Remarks</span>
                          <div className="position-relative">
                            <Field as="textarea" className="notes" name="notes_3" />
                          </div>
                        </div>

                      </div>
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button
                          type="submit"
                          className="add_button"
                        >
                          Save Draft
                        </button>
                        <button type="reset" className="reset_button">
                          <Link to="/createlease">
                            Cancel
                          </Link>
                        </button>
                      </div>
                    </div>
                  </Form>
                </div>
              </>
            )}
          </Formik>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
      </div>
    );
  }
}

export default withRouter(LeaseTermDetails);
